import React from "react"
import { withFormik, FormikProps, FormikErrors, Form } from "formik"
import { styled } from "@mui/material"
import { buttonClasses } from "@mui/base/Button"

import i18n from "config/i18n"
import Button from "components/ui/Button"
import { BatchPaymentFormValues } from "types"

interface FormProps {
  initialValues: {
    amount: number
    bank_name: string
  }
  title: string
  color: string
  disabled: boolean
  onSubmit: (values: BatchPaymentFormValues) => void
}

type Props = FormikProps<BatchPaymentFormValues> & FormProps

const BatchPaymentForm = ({ title, color, disabled }: Props) => {
  return (
    <Wrapper>
      <Submit type="submit" color={color} disabled={disabled}>
        {title}
      </Submit>
    </Wrapper>
  )
}

const BatchPaymentFormWithFormik = withFormik<
  FormProps,
  BatchPaymentFormValues
>({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues }) => initialValues,
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
  validate: (values: BatchPaymentFormValues) => {
    const errors: FormikErrors<BatchPaymentFormValues> = {}

    if (!values.amount) {
      errors.amount = i18n.t("validation.field.required", {
        field: i18n.t("features.batch_payment.amount"),
      })
    }

    return errors
  },
})(BatchPaymentForm)

export default BatchPaymentFormWithFormik

const Wrapper = styled(Form)`
  margin: 16px 10px;
  max-width: 150px;
`

const Submit = styled(Button)`
  border: none;
  background-color: #f2f2f2;
  border-radius: 21.5px;
  flex-basis: 50%;
  height: 43px;
  width: 150px;

  &.${buttonClasses.root} {
    color: ${({ color }) => color};
  }
`
